import React from "react";
import { FaArrowRight, FaUser, FaBolt, FaStar, FaChartColumn } from "react-icons/fa6";
import { BTN_SIZE, Container, H2_SIZE, H3_SIZE } from "../home/ui";

const points = [
  {
    icon: FaUser,
    title: "User-Centric Approach",
    text: "We put your users at the center of every design decision.",
    tone: "bg-[#E6EEFF] text-[#2563EB]",
  },
  {
    icon: FaBolt,
    title: "Modern & Scalable Design",
    text: "Clean, modern designs that grow with your business.",
    tone: "bg-[#FFEDE3] text-[#F97316]",
  },
  {
    icon: FaStar,
    title: "Experienced Team",
    text: "Skilled UI/UX designers with real industry experience.",
    tone: "bg-[#FFF4DB] text-[#F5B301]",
  },
  {
    icon: FaChartColumn,
    title: "Business Focused",
    text: "Designs that not only look good but also drive conversions.",
    tone: "bg-[#DFF7EC] text-[#10B981]",
  },
];

const UiuxWhyChoose = () => (
  <section className="bg-gradient-to-r from-[#F7F7FD] via-[#FAFAFE] to-white py-[48px] lg:py-[64px]">
    <Container className="max-w-[1320px]">
      <div className="grid items-center gap-[36px] lg:grid-cols-[minmax(0,0.85fr)_minmax(0,1.15fr)] lg:gap-[56px]">
        <div>
          <span className="inline-block rounded-full bg-[#ECEBFF] px-[16px] py-[5px] text-[12px] font-semibold uppercase tracking-[0.04em] text-[#3B2A8F]">
            Why Choose Us
          </span>
          <h2 className={`mt-[14px] font-extrabold tracking-tight text-[#0B0D2C] ${H2_SIZE}`}>
            Design That
            {" "}<br />
            <span className="text-[#2B2FD9]">Drives Results</span>
          </h2>
          <p className="mt-[14px] max-w-[460px] text-[15px] leading-[1.6] text-slate-600 sm:text-[16px]">
            We combine creativity, user psychology and data-driven insights to design products that make an impact.
          </p>
          <a
            href="/contact-us"
            className={`group mt-[26px] inline-flex items-center rounded-full bg-gradient-to-r from-[#3D4BF6] to-[#A855F7] font-medium text-white shadow-[0_14px_30px_-14px_rgba(91,61,245,0.75)] transition hover:brightness-110 ${BTN_SIZE}`}
          >
            Let&apos;s Work Together
            <FaArrowRight className="text-[13px] transition group-hover:translate-x-1" />
          </a>
        </div>

        <div className="grid gap-x-[40px] gap-y-[32px] sm:grid-cols-2">
          {points.map((p) => (
            <div key={p.title} className="flex items-start gap-[18px]">
              <span className={`inline-flex h-[60px] w-[60px] shrink-0 items-center justify-center rounded-full text-[24px] ${p.tone}`}>
                <p.icon />
              </span>
              <div>
                <h3 className={`font-bold text-[#0B0D2C] ${H3_SIZE}`}>{p.title}</h3>
                <p className="mt-[6px] max-w-[260px] text-[14px] leading-[1.55] text-slate-500">{p.text}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </Container>
  </section>
);

export default UiuxWhyChoose;
